
import React from 'react'
import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <ul className="tool-wrap">
        <li className="music">
          <div className={`icon-wrap ${this.props.playMusicStatus ? 'play' : ''}`} onClick={() => this.props.onToggleMusic()}>
            <img src={`/img/activity/national-star/${this.props.playMusicStatus ? 'icon_music@2x.png' : 'icon_music_d@2x.png'}`} alt="music" />
          </div>
        </li>
        <li className="rule" onClick={() => this.props.onToggleModal('rules')}>
          <div className="icon-wrap">
            <img src="/img/activity/national-star/icon_rules@2x.png" alt="rule" />
          </div>
        </li>
        <li className='gift' onClick={() => this.props.onToggleModal('rewards')}>
          <div className="icon-wrap">
            <img src="/img/activity/national-star/icon_rewards@2x.png" alt="gift" />
          </div>
        </li>
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/sider/index.js